module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-2-011e3c24476936052dc0ca5a3bcb04c1.png";